<template lang="pug">
    .col-sm-6.col-md-6.col-lg-3
        .iconbox.iconbox__style-02
            .iconbox__icon
                img(:src="image")
            div
                h2.iconbox__title
                    router-link(:to="lenguage.link") {{ lenguage.name }}
                h3.iconbox__subtitle(style="font-size: 16px;")
                    a(style="color: #7d7d7d") {{ lenguage.subtitle }}
                div.iconbox__description(style="text-align:left!important")
                    | {{ lenguage.description }}
</template>

<script>
export default {
    props: ["lenguage", "image"]
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PmHomeService.vue